import { render, staticRenderFns } from "./ModuloNuovo.vue?vue&type=template&id=580d0cfc&"
import script from "./ModuloNuovo.vue?vue&type=script&lang=js&"
export * from "./ModuloNuovo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports